// エラーメッセージリスト エラー画面用
var errorMessageList = {
    'default': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'deviceNotSupport': 'ご利用の端末はサポートされていません。スマートフォンかタブレットよりアクセスをしてください。',
    'cpClosed': 'App Store & iTunes コードの購入ができませんでした。<br />申し訳ございませんが、本キャンペーンのApp Store & iTunes コードは、販売を終了いたしました。',
    'cpClosed2': 'Apple Gift Cardの購入ができませんでした。<br />申し訳ございませんが、本キャンペーンのApple Gift Cardは、販売を終了いたしました。',
    'message_error_ua': '<div><span class="ttlSmall" style="color: #000;">お客さまのブラウザ・端末からはお手続きを行うことができません</span></div><br /><div class="txtRed">セキュリティ強化のため、一部の古いスマートフォン、ブラウザからは、お手続きを行うことができません。<br /><u><a class="txtRed" href ="https://online-shop.mb.softbank.jp/ols/component/rect/info-pcidss1.html">詳しくはこちらをご確認ください</a></u></div>',
    'CDD400003': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400005-2001': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2002': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2003': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2004': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2005': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2006': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2007': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2008': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2009': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-2010': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400005-4009': 'エラーが発生しました。<br /><br />既に登録済みです。',
    'CDD400005-4101': 'エラーが発生しました。<br /><br />お客さまの契約内容では本サービスをご利用いただけません。',
    'CDD400005-4106': 'エラーが発生しました。<br /><br />お支払いの確認が取れていない料金があります。',
    'CDD400005-4109': 'エラーが発生しました。<br /><br />利用限度額以上はご利用いただけません。',
    'CDD400005-4110': 'エラーが発生しました。<br /><br />本サービスをご利用いただけません。',
    'CDD400005-4111': 'エラーが発生しました。<br /><br />本サービスをご利用いただけません。',
    'CDD400005-4114': 'エラーが発生しました。<br /><br />本サービスをご利用いただけません。',
    'CDD400005-4202': 'エラーが発生しました。<br /><br />システムメンテナンス中のため、しばらくたってからお試し下さい。',
    'CDD400006': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400007': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400008': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400009': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400010': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400011': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400012': 'セッションがタイムアウトしました。<br><br>恐れ入りますが、再度お手続きください。',
    'CDD400014': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400015': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400016': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400017': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400019': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400023': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400025': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2001': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2002': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2003': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2004': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2005': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2006': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2011': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2012': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2013': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2014': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2015': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2016': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2017': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2018': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-2022': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-3002': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-3003': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD400026-4009': 'エラーが発生しました。<br /><br />既に登録済みです。',
    'CDD400026-4101': 'エラーが発生しました。<br /><br />お客さまの契約内容では本サービスをご利用いただけません。',
    'CDD400026-4103': 'エラーが発生しました。<br /><br />お客さまの契約内容では本サービスをご利用いただけません。',
    'CDD400026-4104': 'エラーが発生しました。<br /><br />お客さまの契約内容では本サービスをご利用いただけません。',
    'CDD400026-4106': 'エラーが発生しました。<br /><br />お支払いの確認が取れていない料金があります。',
    'CDD400026-4108': 'エラーが発生しました。<br /><br />お客さまの契約内容では本サービスをご利用いただけません。',
    'CDD400026-4111': 'エラーが発生しました。<br /><br />本サービスをご利用いただけません。',
    'CDD400026-4113': 'エラーが発生しました。<br /><br />本サービスをご利用いただけません。',
    'CDD400026-4114': 'エラーが発生しました。<br /><br />本サービスをご利用いただけません。',
    'CDD400026-4202': 'エラーが発生しました。<br /><br />システムメンテナンス中のため、しばらくたってからお試し下さい。',
    'CDD400027': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400028': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400029': 'App Store & iTunes コードの購入ができませんでした。<br />申し訳ございませんが、本キャンペーンのApp Store & iTunes コードは、販売を終了いたしました。',// 未使用
    'CDD400030': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400031': 'お申し込み開始時点から、販売内容が変更となっております。<br /><br />恐れ入りますが、最初のページに戻り、再度お申し込みください。',
    'CDD400032': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400033': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400034': 'お申し込み開始時点から、販売内容が変更となっております。<br /><br />恐れ入りますが、最初のページに戻り、再度お申し込みください。',
    'CDD400035': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400039-0001': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400040': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400041': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400043': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400044': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400045': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400046': '不正なアクセスです。<br/>恐れ入れますが、最初からやり直してください。',
    'CDD400048': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400050': 'お申し込み開始時点から、販売内容が変更となっております。<br /><br />恐れ入りますが、最初のページに戻り、再度お申し込みください。',
    'CDD400051': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD400052': '不正なアクセスです。<br/>恐れ入れますが、最初からやり直してください。',
    'CDD400053': '不正なアクセスです。<br/>恐れ入れますが、最初からやり直してください。',
    'CDD400054': 'エラーが発生しました。<br /><br />お客さまの契約内容では本サービスをご利用いただけません。',
    'CDD400055': '<div class="center">セキュリティロックがかかりました</div><br><div class="left">誤った内容が繰り返し入力されたため、本人確認が必要な画面にロックがかかりました。<br/><br/>ロックは翌日の午前0時以降に自動的に解除されます。恐れ入りますが、解除されるまでお待ちください。</div>',
    'CDD400056': '<div class="center">セキュリティロックがかかりました</div><br><div class="left">誤った内容が繰り返し入力されたため、本人確認が必要な画面にロックがかかりました。<br/><br/>ロックは翌日の午前0時以降に自動的に解除されます。恐れ入りますが、解除されるまでお待ちください。</div>',
    'CDD500006': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500007': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500008': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500009': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500010': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500011': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500012': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500013': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500014': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500015': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500016': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500017': 'メンテナンス中です。しばらくお待ち下さい。',
    'CDD500018': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500019': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500020': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500021': 'エラーが発生しました。<br /><br />システムエラーが発生しました。',
    'CDD500022': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。',
    'CDD500023': 'すでに購入は完了しております。',
    'CDD500024': 'ただいま、大変混み合っております。<br />恐れ入りますが、しばらく経ってからご利用ください。'
};

// エラーメッセージリスト alert用
var alertMessageList = {
    'CDD400020': '入力いただいたクーポンコードは有効ではありません。大文字小文字の入力間違いがないか、今一度ご確認ください。',
    'CDD400021': '入力いただいたクーポンコードは有効期間外のためご利用いただけません。',
    'CDD400022': 'エラーが発生しました。\n\n入力いただいたクーポンコードはすでにご利用済です。',
    'CDD400023-0006': '「贈り主のEメールアドレス」に正しくない文字が入力されています。',
    'CDD400023-0010': '「お届け先のEメールアドレス」に有効なEメールアドレスを入力してください。',
    'CDD400039-0002': '有効なEメールアドレスを入力してください。'
};

var ajaxComponent = {
    /** ルート */
    // rootUrl : location.protocol + '//' + location.hostname + ':' + location.port + '/cmecsSelf/cdd/services',
    rootUrl: '/cmecsSelf/cdd/services',
    /**
     * ajax通信を行うコンポーネント。結果をReturnするためdoneは外出し。
     * 
     * @param endPath service以下のpath
     * @param httpMethod 例：'GET', 'POST'
     * @param contentType 例；'application/json'
     * @param requestBody requestBody. JsonParse必須
     */
    request: function (endPath, httpMethod, contentType, requestBody) {
        var url = ajaxComponent.rootUrl + endPath;
        return $.ajax({
                url: url,
                async: false,
                cache: false,
                type: httpMethod,
                contentType: contentType,
                dataType: "json",
                headers: {
                    "token": sessionStorage.getItem("token")
                },
                data: requestBody
            }).done(function (data, textStatus, xhr) {
                if (xhr.responseJSON &&
                    xhr.responseJSON.error &&
                    xhr.responseJSON.error.errorCode) { 
                    // header から サーバー側のtokenをリフレッシュ
                    utility.tokeReflush(xhr);
                    // エラーチェック
                    checkError(xhr);
                    // エラーがすぐに発生、そして阻止下へ運行
                    throw new error();
                }
            }).fail(function (xhr, textStatus, errorThrown) {

                // 静的サーバー規制の場合、リダイレクトのHTMLをレスポンス
                if (textStatus.toLowerCase() === "parsererror" && xhr.responseText && xhr.responseText.toLowerCase().indexOf("</html>") > 0) {
                    document.write(xhr.responseText);
                    throw new error();
                }

                // header から サーバー側のtokenをリフレッシュ
                utility.tokeReflush(xhr);

                //HTTP ERROR判定処理
                switch (xhr.status) {
                    // 400ErrorはAlertで対応
                    case 400:
                        checkError(xhr);
                        break;
                        // case 401, 403, 404, 500, 502, 503:
                    case 500:
                        checkError(xhr);
                        break;
                    case 503:
                        checkError(xhr);
                        break;
                    default:
                        window.location.replace(`error.html?status=${xhr.status}&errorCode=default`);
                        break;
                }
            });
    }
}

/**
 * エラーコードからメッセージを取得する。
 * @param {string} errorCode エラーコード
 * @param {string} detailCode 詳細コード
 */
function getScreenErrorMessage(errorCode, detailCode) {

    var fullErrorCode = errorCode;

    if (typeof detailCode !== "undefined" && detailCode !== "null" && detailCode !== null) {
        fullErrorCode = fullErrorCode + "-" + detailCode;
    }

    var message;
    // alert用のメッセージ
    var alertMsg = alertMessageList[fullErrorCode];
    // エラー画面用のメッセージ
    var errMsg = errorMessageList[fullErrorCode];

    if (alertMsg) {
        // alert用のメッセージを設定
        message = alertMsg;
    } else if (errMsg) {
        // エラー画面用のメッセージを設定
        message = errMsg;
    } else {
        // 想定外でメッセージが作れなかった場合、全部ただ混みエラーにする
        message = errorMessageList['default'];
    }

    return message;
}

// エラーコードのハンドリング用共通メソッド
var checkError = function (data) {
    if (data.responseJSON &&
        data.responseJSON.error &&
        data.responseJSON.error.errorCode) {

        var errorCode = data.responseJSON.error.errorCode;
        var detailCode = data.responseJSON.error.detailCode;

        var fullErrorCode = errorCode;
        if (typeof detailCode !== "undefined" && detailCode !== "null" && detailCode !== null) {
            fullErrorCode = fullErrorCode + "-" + detailCode;
        }
        var alertMsg = alertMessageList[fullErrorCode];
        // alertメッセージを表示する。
        if (alertMsg) {
            window.alert(alertMsg);
        } else {
            var errMsg = errorMessageList[fullErrorCode];
            // エラー画面へ遷移する。
            if (errMsg) {
                if (detailCode) {
                    window.location.replace(`error.html?status=${data.status}&errorCode=${errorCode}&detailCode=${detailCode}`);
                } else {
                    window.location.replace(`error.html?status=${data.status}&errorCode=${errorCode}`);
                }
            } else {
                window.location.replace(`error.html?status=${data.status}&errorCode=unknown`);
            }
        }
    } else {
        window.location.replace(`error.html?status=${data.status}&errorCode=undefined`);
    }
}